export const wrapperStyles = {
  bg: "primary"
};
